import { render, staticRenderFns } from "./dislike_report.vue?vue&type=template&id=5e9b2393&scoped=true&"
import script from "./dislike_report.vue?vue&type=script&lang=js&"
export * from "./dislike_report.vue?vue&type=script&lang=js&"
import style0 from "./dislike_report.vue?vue&type=style&index=0&id=5e9b2393&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9b2393",
  null
  
)

export default component.exports